import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type DeleteTestUserResponseType = {};

export const useDeleteTestUser = (
  options?: MutationOptions<
    DeleteTestUserResponseType,
    number,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete<
        ApiResponse<DeleteTestUserResponseType>
      >(`/campaign/test-user/${id}`);

      return data.data;
    },
    ...options,
  });
